import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTransferArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 12,
	viewBox: "0 0 15 12",
	...props,
	children: /* @__PURE__ */ _jsx("polygon", {
		points: "8.6 12 6.1 12 11 7.1 .5 7.1 .5 5.3 11 5.3 6.1 .4 8.6 .4 14.4 6.2",
		transform: "matrix(-1 0 0 1 15 0)"
	})
});
export default SvgTransferArrowLeft;
